import { createFileRoute } from "@tanstack/react-router";
import { PageHeader } from "@/components/page-header";
import { StatusBadge } from "@/components/status-badge";
import { NewGalleryDialog } from "@/components/forms/new-gallery-dialog";
import { galleries } from "@/mocks/data";

export const Route = createFileRoute("/galleries")({
  head: () => ({
    meta: [
      { title: "Galleries — Studio OS" },
      { name: "description", content: "Client galleries, proofing, and delivery." },
    ],
  }),
  component: GalleriesPage,
});

function GalleriesPage() {
  return (
    <div className="mx-auto max-w-7xl px-6 py-8 lg:px-10 lg:py-10">
      <PageHeader
        title="Galleries"
        description="Upload, proof, and deliver work to clients."
        actions={<NewGalleryDialog />}
      />
      <div className="grid grid-cols-2 gap-5 md:grid-cols-3 xl:grid-cols-4">
        {galleries.map((g) => (
          <article key={g.id} className="group cursor-pointer space-y-3">
            <div
              className="aspect-[4/5] w-full rounded-xl ring-1 ring-inset ring-border transition group-hover:ring-foreground/20"
              style={{
                background: `linear-gradient(135deg, oklch(0.6 0.08 ${g.coverHue}) 0%, oklch(0.3 0.04 ${g.coverHue}) 100%)`,
              }}
            />
            <div className="space-y-1">
              <div className="flex items-start justify-between gap-2">
                <h3 className="truncate text-sm font-medium">{g.title}</h3>
                <StatusBadge status={g.status} />
              </div>
              <p className="text-xs text-muted-foreground">{g.client}</p>
              <p className="font-mono text-[10px] uppercase tracking-wider text-muted-foreground">
                {g.shootDate} · {g.imageCount} images
              </p>
            </div>
          </article>
        ))}
      </div>
    </div>
  );
}
